LS.util.route({
	'$property': {
		'$slug': {
			'$entry': {
				':load': 'property',
				':unload': 'property:unload'
			}
		}
	}
});